"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
export default function HowItWorks() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: section2Ref,
    isVisible: section2Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: section3Ref,
    isVisible: section3Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const {
    ref: section4Ref,
    isVisible: section4Visible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const steps = [{
    number: 1,
    title: "Free Fund Search",
    description: "We research public records to see if funds may exist in your name.",
    ref: section1Ref,
    visible: section1Visible
  }, {
    number: 2,
    title: "Claim Verification",
    description: "We confirm eligibility and identify rightful ownership.",
    ref: section2Ref,
    visible: section2Visible
  }, {
    number: 3,
    title: "Filing & Recovery Process",
    description: "We handle all the paperwork and legal filings on your behalf, navigating the complex recovery process with transparency and integrity.",
    ref: section3Ref,
    visible: section3Visible
  }, {
    number: 4,
    title: "You get Paid",
    description: "Once approved, your funds are released and distributed to you. We ensure a smooth, timely transfer of what is rightfully yours. No upfront fee, We get paid only if you get paid",
    ref: section4Ref,
    visible: section4Visible
  }];
  return <section id="how-it-works" className="relative min-h-screen py-24 px-6 from-dark-background via-dark-background/95 to-dark-background dark-section overflow-hidden !text-[hsl(0,0%,100%)] !bg-[hsl(0,0%,100%)]">
      <div className="container mx-auto max-w-4xl relative z-10">
        <div className="text-center mb-20">
          
          <h2 className="text-4xl font-bold mb-6 !text-[hsl(224,76%,48%)] md:text-5xl">
            How It Works
          </h2>
          <p className="text-lg max-w-2xl mx-auto !text-[hsl(224,76%,48%)]">How Roberts &amp; Roberts Recovery Solutions Helps</p>
        </div>

        <div className="relative">
          {}
          <div className="absolute left-8 md:left-12 top-0 bottom-0 w-0.5 bg-border/30" />
          <div className="absolute left-8 md:left-12 top-0 w-0.5 bg-gradient-to-b from-primary via-secondary to-accent transition-all duration-[2000ms] ease-out" style={{
          height: section4Visible ? "100%" : section3Visible ? "75%" : section2Visible ? "50%" : section1Visible ? "25%" : "0%"
        }} />

          {}
          <div className="space-y-16">
            {steps.map((step, index) => <div key={step.number} data-index={index}>
                <div ref={step.ref} className={`relative transition-all duration-700 ease-out ${step.visible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
                  <div className="flex items-start gap-8">
                    {}
                    <div className="relative z-10 shrink-0">
                      <div className={`size-16 md:size-20 rounded-full flex items-center justify-center font-bold text-xl md:text-2xl transition-all duration-500 ${step.visible ? "bg-primary text-foreground-primary shadow-strong scale-100" : "bg-muted text-muted-foreground scale-90"}`}>
                        {step.number}
                      </div>
                    </div>

                    {}
                    <Card className="flex-1 bg-background/50 backdrop-blur-sm border border-border/50 hover:border-primary/30 transition-all duration-300">
                      <div className="p-6">
                        <h3 className="text-2xl font-semibold text-foreground mb-3">
                          {step.title}
                        </h3>
                        <p className="leading-relaxed !text-[hsl(0,0%,100%)]">
                          {step.description}
                        </p>
                      </div>
                    </Card>
                  </div>

                  {}
                  {index < steps.length - 1 && <div className="flex justify-center my-8">
                      <ArrowDown className={`size-6 text-accent transition-all duration-1000 ${step.visible ? "opacity-100 animate-pulse" : "opacity-0"}`} />
                    </div>}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}